import {Language} from "./languages";

export const cvFiles: Record<Language, {href: string; download: string}> = {
  en: {
    href: "/cv/Santiago_Molano_CV_EN.pdf",
    download: "Santiago_Molano_CV_EN.pdf",
  },
  es: {
    href: "/cv/Santiago_Molano_CV_ES.pdf",
    download: "Santiago_Molano_CV_ES.pdf",
  },
};
